var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 16.333,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#0096DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3327 48.6666V67.3333H9.66602C9.66602 62.3826 11.6327 57.6347 15.1334 54.134C18.634 50.6333 23.382 48.6666 28.3327 48.6666V48.6666ZM28.3327 46.3333C20.5977 46.3333 14.3327 40.0683 14.3327 32.3333C14.3327 24.5983 20.5977 18.3333 28.3327 18.3333C36.0677 18.3333 42.3327 24.5983 42.3327 32.3333C42.3327 40.0683 36.0677 46.3333 28.3327 46.3333ZM49.3327 55.6666H51.666V67.3333H32.9993V55.6666H35.3327V53.3333C35.3327 51.4768 36.0702 49.6963 37.3829 48.3836C38.6957 47.0708 40.4762 46.3333 42.3327 46.3333C44.1892 46.3333 45.9697 47.0708 47.2824 48.3836C48.5952 49.6963 49.3327 51.4768 49.3327 53.3333V55.6666ZM44.666 55.6666V53.3333C44.666 52.7145 44.4202 52.121 43.9826 51.6834C43.545 51.2458 42.9515 51 42.3327 51C41.7138 51 41.1203 51.2458 40.6828 51.6834C40.2452 52.121 39.9993 52.7145 39.9993 53.3333V55.6666H44.666Z",
    fill: "#0096DD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/Icon_Avatar.af1b504194582bbb45ad6089531496ed.svg";
export { ForwardRef as ReactComponent };